export default "__VITE_ASSET__DSTqgkdz__"